import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthService } from '../service/auth/auth.service';
import { RevenueCatService } from '../service/billing/revenuecat.service';
import { BrandService } from '../service/brand/brand.service';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './admin-layout.component.html',
  styleUrl: '../dashboard/dashboard-layout.component.css'
})
export class AdminLayoutComponent implements OnInit {
  userName = '';
  sidebarOpen = false;

  constructor(
    private authService: AuthService,
    private revenueCat: RevenueCatService,
    private brand: BrandService,
  ) {
    const user = this.authService.getUser();
    this.userName = user?.name ?? '';
  }

  ngOnInit(): void {
    if (this.brand.showBilling) {
      void this.revenueCat.ensureIdentified(this.authService.getUser());
    }
  }

  toggleSidebar(): void {
    this.sidebarOpen = !this.sidebarOpen;
  }

  closeSidebar(): void {
    this.sidebarOpen = false;
  }
}
